import { configureStore } from '@reduxjs/toolkit';
import systemsReducer from './slices/systemSlice';
import bessReducer from './slices/bessSlice';
import sitesReducer from './slices/sitesSlice';

export const store = configureStore({
  reducer: {
    systems: systemsReducer,
    bess: bessReducer,
    sites: sitesReducer,
  },
});

